import { gql } from "graphql-request";

export const LIST_USERS_QUERY = gql`query listUsers($selectFields: String!, $inFilters:AWSJSON!, $notInFilters: AWSJSON! $pageLimit:Int, $pageOffset: Int) {
  listUsersDynamicFilter(input:{selectFields: $selectFields, inFilters: $inFilters, notInFilters:$notInFilters, pageLimit: $pageLimit, pageOffset:$pageOffset}){
    message
    statusCode
  }
}`;